import React, { FC, useState } from 'react';
import { InputText } from '@agro1desenvolvimento/react-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

interface PasswordInputProps {
  id: string;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  label: string;
  placeholder?: string;
  required?: boolean;
  autoFocus?: boolean;
  className?: string;
  title?: string;
}

const PasswordInput: FC<PasswordInputProps> = ({
  id,
  value,
  onChange,
  label,
  placeholder = 'Digite sua senha',
  required = false,
  autoFocus = false,
  className = 'auth-input',
  title = 'Senha',
}) => {
  const [showPassword, setShowPassword] = useState(false);

  return (
    <div className="p-col-12 auth-field">
      <label htmlFor={id} className="auth-label">
        {label}
      </label>
      <div className="auth-input-container">
        <FontAwesomeIcon
          icon={showPassword ? 'eye-slash' : 'eye'}
          className="auth-icon clickable"
          onClick={() => setShowPassword(!showPassword)}
        />
        <InputText
          id={id}
          type={showPassword ? 'text' : 'password'}
          required={required}
          autoFocus={autoFocus}
          value={value}
          title={title}
          placeholder={placeholder}
          className={className}
          onChange={onChange}
        />
      </div>
    </div>
  );
};

export default PasswordInput;
